import React from "react";
import PropTypes from "prop-types";

import StoryBody from "components/Library/StoryBody";
import ResponsiveImage from "components/Library/ResponsiveImage";
import { MicrodataContext } from "config/contexts";
import { IMAGE_ASPECT_RATIO } from "config/constants";

import styles from "./PrimaryImage.css";

export default function PrimaryImage({ image, lazyload }) {
  if (!image || !Object.keys(image).length) { return null } // APIs are inconsistent between null and empty object

  // Handle entity maps, add "caption" type
  const captionBlocks = image.caption && image.caption.blocks && {
    ...image.caption,
    blocks: image.caption.blocks.map((block) => ({ ...block, type: "caption" })),
  };

  return (
    <MicrodataContext.Consumer>
      {(microdata) => {
        const figProps = microdata ? {
          itemProp: "image",
          itemScope: true,
          itemType: "http://schema.org/ImageObject",
        } : {};

        // for some reason the structured data tool can't find its way all the way down to the img tag, so this meta tag provides image data
        return (
          <figure {...figProps}>
            {microdata && <meta itemProp="url" content={image.crops.lead.url} />}
            <div className={styles.root}>
              <ResponsiveImage
                src={image.crops.lead.url}
                alt={image.alt_text}
                lazyload={lazyload}
                aspectRatio={IMAGE_ASPECT_RATIO.LEAD}
              />
            </div>
            {captionBlocks && (
              <figcaption className={styles.caption}>
                <StoryBody story={{ blocks: captionBlocks }} />
              </figcaption>
            )}
          </figure>
        );
      }}
    </MicrodataContext.Consumer>
  );
}

PrimaryImage.defaultProps = {
  lazyload: true,
};

PrimaryImage.propTypes = {
  lazyload: PropTypes.bool,
  image: PropTypes.shape({
    alt_text: PropTypes.string,
    caption: PropTypes.shape({
      blocks: PropTypes.array.isRequired,
      entityMap: PropTypes.array.isRequired,
    }),
    crops: PropTypes.shape({
      lead: PropTypes.shape({
        url: PropTypes.string.isRequired,
      }).isRequired,
    }),
  }),
};
